import { NgModule} from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AuthModule } from '@shared/auth/auth.module';
import { JwtModule } from '@auth0/angular-jwt'; 
import { AnalyticsModule } from './shared/services/google-tag-manager/analytics/analytics.module';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ScrollModule } from './shared/scroll/scroll.module';

export function tokenGetter(): string {
    return localStorage.getItem('token');
  }

@NgModule({
    imports: [
    JwtModule.forRoot({
        config: {
            tokenGetter: tokenGetter,
            allowedDomains: ['localhost:5000'],
            disallowedRoutes: []
        }
        }),
      AuthModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js'),
      HammerModule,
      AnalyticsModule.forRoot(),
      NgScrollbarModule,
      ScrollModule
    ]
  })
  export class SharedModule {}
  
